export default "__VITE_ASSET__Cg_tYl58__"